var React = require('react');

function Marketing (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"m3 7.824 4.5 2.814L12 7.824 7.5 5 3 7.824Zm9 0 4.5 2.814L21 7.824 16.5 5 12 7.824Zm-9 5.603 4.5 2.814 4.5-2.814-4.5-2.824L3 13.427Zm13.5-2.824L12 13.427l4.5 2.814 4.5-2.814-4.5-2.824Zm-8.973 6.574L12.036 20l4.5-2.823-4.5-2.815-4.509 2.815Z"}));
}

Marketing.defaultProps = {"fill":"none","viewBox":"0 0 24 24"};

module.exports = Marketing;

Marketing.default = Marketing;
